// @flow strict

import * as React from 'react';
import styles from './styles.scss';
import ArticleMeta from '../../../../internal/ArticleMeta';
import type { ArticleMetaType } from '../../../../internal/ArticleMeta';

export type TitleType = {|
  ...ArticleMetaType,
  title: string,
  intro: string,
|};

export default (props: TitleType) => {
  return (
    <div className={styles.titleContainer}>
      <h1 className={styles.title}>{props.title}</h1>
      <p className={styles.intro}>{props.intro}</p>
      <ArticleMeta author={props.author} categories={props.categories} date={props.date} />
    </div>
  );
};
